import React from 'react';
import './HintText.css';

const HintText = ({ definition }) => {
  return (
    <div className="hint-text">
      {definition}
    </div>
  );
};

export default HintText; 